import Repository from '@/repositories/marketing'
const resource = '/segments'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    uploadExport(segment_id,config){
        return Repository.get(`${resource}/${segment_id}/upload_export.json`, config)
    },
    bulkRefresh(config){
        return Repository.post(`${resource}/bulk_refresh.json`, config)
    },
    refreshCount(segment_id,config){
        return Repository.get(`${resource}/${segment_id}/refresh_count.json`, config)
    },
    getAllFields(config){
        return Repository.get(`/get_all_fields.json`, config)
    },
    export(segment_id, data, config){
        return Repository.post(`${resource}/${segment_id}/export.json`, data, config)
    },
    bulkDelete(config){
        return Repository.delete(`${resource}/bulk_delete.json`, config)
    },
    delete(id){
        return Repository.delete(`${resource}/${id}.json`)
    },
    archiveRecord(id,config){
        return Repository.post(`${resource}/${id}/archive_record.json`, config)
    },
    checkRecordInUse(id,config){
        return Repository.get(`${resource}/${id}/check_modules_in_use.json`, config)
    },
    fetchById(segment_id) {
        return Repository.get(`${resource}/${segment_id}.json`)
    },
    getRecentActivities (segment_id, config) {
        return Repository.get(`${resource}/${segment_id}/recent_activities.json`, config)
    },
    getTimelineStats (segment_id, config) {
        return Repository.get(`${resource}/${segment_id}/campaign_sent_schedule.json`, config)
    },
    getTimelineFilters (segment_id,config){
        return Repository.get(`${resource}/${segment_id}/filters.json`,config)
    },
    //api's used in next gen segments
    getCategoriesSchema(){
        return Repository.get(`${resource}/get_segment_category_schema.json`)
    },
    getFilterSchema(config){
        return Repository.get(`${resource}/get_segment_filter_fields.json`,config)
    },
    create(config){
        return Repository.post(`${resource}.json`, config)
    },
    getSegmentById(segmentId){
        return Repository.get(`${resource}/${segmentId}/segment_details.json`)
    },
    update(segmentId,data){
        return Repository.put(`${resource}/${segmentId}.json`, data)
    },
    //this method used in create/edit segment to fetch the data from dynamics api's
    fetchSegmentsData(apiURL,config){
        return Repository.get(`${apiURL}`, config)
    },
    fetchOptionalFilter(){
        return Repository.get(`${resource}/get_optional_filter_field.json`)
    },
    fetchRelationalOptionalFilter(config){
        return Repository.get(`${resource}/get_segment_operator_fields.json`,config)
    },
    /**
     * This function is used to fetch and return a complete list of fields 
     * required for processing or display purposes in the segment export.
     * @returns {Array} An array containing all the retrieved fields.
     * Note: Changes under UID
     */
    fetchAllFields(config){
        return Repository.get(`${resource}/get_all_fields.json`, config)
    },
}
